import { REDUCER } from '../reducers/reducersConst';
import { setSkinInStorage } from '../shared';
import * as skinUtils from '../utils/skinUtils';

let crossPlatformSpecialization;
export let configure = injectedCrossPlatformSpecialization => {
  crossPlatformSpecialization = injectedCrossPlatformSpecialization;
};

export let setTheme = (theme = {}) => {
  return {
    type: REDUCER.THEME.SET_THEME,
    theme
  };
};

export let setLoadedTheme = () => {
  return {
    type: REDUCER.THEME.LOADED_THEME,
    loaded: true
  };
};

export let setSkinUrl = skinUrl => {
  return {
    type: REDUCER.THEME.SKIN_URL,
    skinUrl
  };
};

/**
 * Get the theme settings and save it in localStorage. If the service is down,
 * get the localStorage Config.
 * */
export let loadAndApplySkin = () => {
  return async (dispatch, getState) => {
    const customer = getState().school.school.customer;
    if (customer && customer.id && customer.id !== -1) {
      return dispatch(crossPlatformSpecialization.loadAndApplySkin(customer.id));
    }
  };
};

export let applySkin = skin => {
  return async dispatch => {
    skinUtils.setSkinColorsToCSS(skin.colors);
    skinUtils.setFontsAndFavicon(skin.urlFonts, skin.images.logos.favicon);
    setSkinInStorage(skin);
    dispatch(setTheme(skin));
    dispatch(setLoadedTheme());
  };
};
